import React from 'react'
import { Table, Divider, DatePicker, Button, Input } from 'antd'
import moment from 'moment'
import Cell from '../../../components/Cell'
import Crud from '../../../components/Crud'
import Exception from '../../../Exception'
import { queryComplementosPago } from './query-list'
import ComplementoPagoModal from './modal'

export class ComplementosPagoList extends React.Component {
  /**
   * Constructor
   * @param {Object} props
   */
  constructor(props) {
    super(props)

    this.columns = Cell.buildList([
      { title: 'FECHA', dataIndex: 'dFecha', render: (val) => (
        <span>{moment(val).format('DD MMM YY')}</span>
      )},
      { title: 'INFORMACIÓN', dataIndex: 'sCfdiUUID', render: (val, record) => (
        <Button
          size='small'
          type='primary'
          onClick={() => this.modal.load(record.iId)}
          children={val || '<S/N>'}
        />
      )},
      { title: 'INFORMACIÓN', dataIndex: 'sCfdiUUID', render: (val, record) => (
        !record.archivoXml ? null : (
          <span>{record.archivoXml.sDescripcion}</span>
        )
      )}
    ])

    this.state = {
      loading: false,
      inicio: -1,
      termino: -1,
      search: '',
      data: [],
      lookup: [],
    }

    this.modal = null
  }

  /**
   * Invocado cuando el componente es montado
   */
  componentDidMount() {
    const fecha = moment()
    this.fetch(
      fecha.clone().startOf('month').add(-3, 'months').format('YYYY-MM-DD'),
      fecha.endOf('month').format('YYYY-MM-DD')
    )
  }

  /**
   * Cargar
   *
   */
  fetch = async(inicio = -1, termino = -1, search = '') => {
    try {
      this.setState({ loading: true, query: { inicio, termino } })

      const likeSearch = {$like: `%${search}%`}
      const filter = search.length > 0 ?
        { sFolio: likeSearch } :
        { dKernelFechaRegistro: { $between: [
            inicio,
            moment(termino).endOf('day').format('YYYY-MM-DD HH:mm:ss')
          ]}
        }

      const response = await queryComplementosPago(filter)

      this.setState({
        data: response.data,
        loading: false,
        inicio,
        termino,
        search,
      })
    } catch (error) {
      this.setState({
        data: [],
        loading: false,
      })
      Exception.load(error).show()
    }
  }

  /**
   *
   */
  reload = () => {
    this.fetch(
      this.state.inicio,
      this.state.termino,
      this.state.search
    )
  }

  /**
   * Render
   */
  render() {
    const crud = (
      <Crud
        buttons={['reload']}
        onReload={() => this.fetch(
          this.state.inicio,
          this.state.termino,
          this.state.search
        )}
      />
    )

    const tableTitle = (
      <div>
        <DatePicker.RangePicker
          defaultValue={[moment().startOf('month'), moment().endOf('month')]}
          onChange={
            (items, fechas) =>
              this.fetch(
                fechas[0].length > 0 ? fechas[0] : -1,
                fechas[1].length > 0 ? fechas[1] : -1,
                this.state.search,
              )
          } />
        <Divider type='vertical' />
        {crud}
        <Divider type='vertical'/>

        <Input.Search
          placeholder='Buscar'
          style={{ width: 185 }}
          onSearch={value =>
            this.fetch(this.state.inicio, this.state.termino, value.trim())
          }
          allowClear
        />
      </div>
    )

    return (
      <div style={{ flex: 1 }}>
        <Table
          rowKey='iId'
          size='small'
          rowClassName='row-pure'
          dataSource={this.state.data}
          columns={this.columns}
          loading={this.state.loading}
          pagination={false}
          title={() => tableTitle}
        />

        <ComplementoPagoModal
          ref={ref => this.modal = ref}
          onDelete={this.reload}
        />
      </div>
    )
  }
}
